// extracted by mini-css-extract-plugin
export var statItem = "_kw-1";
export var statsRow = "_kw-0";